import AsyncStorage from '@react-native-async-storage/async-storage'

export const storage = {
  get: async (key) => {
    try {
      return await AsyncStorage.getItem(key)
    } catch { return null }
  },
  set: async (key, value) => {
    try {
      await AsyncStorage.setItem(key, String(value))
    } catch {}
  },
  remove: async (key) => {
    try {
      await AsyncStorage.removeItem(key)
    } catch {}
  },
}